class BuildYourBundle extends HTMLElement {
  constructor() {
    super();
    this.steps = this.querySelectorAll('.build-your-bundle__step');
    this.progressFill = this.querySelector('.build-your-bundle__progress-fill');
    this.currentStep = 0;

    this.init();
  }

  connectedCallback() {
    this.setupCartEventListeners();

    // Ajout : ouvrir la popup bundle au clic sur le composant
    this.addEventListener('click', async (e) => {
      // Activer le loading spinner
      const addProductButton = this.querySelector('.build-your-bundle__add-product');
      const loadingSpinner = this.querySelector('.loading__spinner');

      if (addProductButton) {
        addProductButton.classList.add('loading');
      }
      if (loadingSpinner) {
        loadingSpinner.classList.remove('hidden');
      }

      try {
        const bundlePopup = document.querySelector('bundle-popup');
        if (bundlePopup) {
          // Utiliser data-product-id du composant build-your-bundle
          const productId = this.dataset.productId;
          if (productId) {
            await bundlePopup.showForProduct(productId);
          } else {
            // Fallback : utiliser le premier produit du panier
            await bundlePopup.loadCartState();
            if (bundlePopup.cartItems.length > 0) {
              const firstCartItem = bundlePopup.cartItems[0];
              await bundlePopup.showForProduct(firstCartItem.product_id);
            }
          }

          await bundlePopup.open();
        }
      } finally {
        // Reset du loading spinner
        if (addProductButton) {
          addProductButton.classList.remove('loading');
        }
        if (loadingSpinner) {
          loadingSpinner.classList.add('hidden');
        }
      }
    });
  }

  init() {
    // Animation d'entrée
    this.animateEntry();
  }

  setupCartEventListeners() {
    // Écouter les mises à jour du panier comme dans bundle-popup.js
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      this.updateProgressFromCart();
    });

    // Écouter les événements de panier personnalisés
    document.addEventListener('cart:updated', () => {
      this.updateProgressFromCart();
    });

    // Initialiser la progress bar avec l'état actuel du panier
    this.updateProgressFromCart();
  }

  async updateProgressFromCart() {
    try {
      // Récupérer l'état actuel du panier
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (cart && cart.items) {
        // Filtrer les items pour exclure les packs et les produits avec "Feuille de soins"
        const filteredItems = cart.items.filter((item) => {
          const isNotPack = item.product_type !== 'pack';
          const hasNoFeuilleDesoins = !item.properties || !item.properties['Feuille de soins'];
          return isNotPack && hasNoFeuilleDesoins;
        });

        // Calculer le nombre total d'articles filtrés dans le panier
        const totalItemsInCart = filteredItems.reduce((total, item) => total + item.quantity, 0);

        // Gérer l'attribut data-has-item
        this.handleBundleVisibility(totalItemsInCart);

        // Mettre à jour la progress bar avec le nombre d'articles
        this.updateFromCart(totalItemsInCart);
      } else {
        // Panier vide
        this.handleBundleVisibility(0);
        this.updateFromCart(0);
      }
    } catch (error) {
      // Erreur silencieuse
    }
  }

  handleBundleVisibility(itemCount) {
    const hasItems = itemCount > 0;
    const currentHasItems = this.getAttribute('data-has-item') === 'true';

    if (hasItems !== currentHasItems) {
      // Mettre à jour l'attribut data-has-item
      this.setAttribute('data-has-item', hasItems.toString());
    }
  }

  setActiveStep(stepIndex) {
    this.currentStep = stepIndex;

    // Mise à jour des classes actives
    this.steps.forEach((step, index) => {
      step.classList.toggle('is-active', index <= stepIndex);
    });

    // Mise à jour de la barre de progression
    if (this.currentStep > 0) {
      this.progressFill.style.width = '100%';
    } else {
      this.progressFill.style.width = '';
    }

    // Dispatch d'un événement personnalisé
    this.dispatchEvent(
      new CustomEvent('bundle:stepChanged', {
        detail: {
          step: stepIndex + 1,
          totalSteps: this.steps.length,
        },
        bubbles: true,
      }),
    );
  }

  animateEntry() {
    // Animation séquentielle des étapes
    this.steps.forEach((step, index) => {
      setTimeout(() => {
        step.style.opacity = '0';
        step.style.transform = 'translateY(1rem)';
        step.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

        requestAnimationFrame(() => {
          step.style.opacity = '1';
          step.style.transform = 'translateY(0)';
        });
      }, index * 100);
    });
  }

  // Méthode pour intégration avec le panier
  updateFromCart(cartItemCount) {
    const stepIndex = Math.min(cartItemCount - 1, this.steps.length - 1);
    if (stepIndex >= 0) {
      this.setActiveStep(stepIndex);
    }
  }
}

customElements.define('build-your-bundle', BuildYourBundle);
